import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../CSS/Login.css';
import CryptoJS from 'crypto-js';

function LoginRegister() {
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [userType, setUserType] = useState('');
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const key = process.env.REACT_APP_FRONT_CODE;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${apiUrl}/api/register/login/${username}/${password}`, { userType: userType });
      if (response.status === 201) {
        alert('You have successfully registered!');
      } else if (response.status === 203) {
        throw new Error('Repeated username');
      }
      const encryptedPassword = CryptoJS.AES.encrypt(password, key).toString();
      const userInfoResponse = await axios.post(`${apiUrl}/api/login`, { username, encryptedPassword });
      if (userInfoResponse.status === 200) {
        const userData = userInfoResponse.data.user;
        if (!userData) {
          throw new Error('Invalid username or password');
        }
        // Store user data and role in localStorage
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('role', userData.UserType);
        switch (userData.UserType) {
          case 'Dispatcher':
            console.log("user type: ", userData.UserType);
            navigate("/dispatcher_Dispatcher");
            break;
          case 'QualityInspector':
            console.log("user type: ", userData.UserType);
            navigate("/QA_home");
            break;
          case 'FrontDesk':
            console.log("user type: ", userData.UserType);
            navigate("/front_desk");
            break;
          default:
            console.log("user type: ", userData.UserType);
            navigate("/HomePage");
        }
      }
    } catch (error) {
      alert(error);
    }
  };

  const userTypes = [
    { value: "FrontDesk", label: "Front Desk" },
    { value: "Dispatcher", label: "Dispatcher" },
  ];

  return (
    (<div className="login-container">
      <h2>{t('Register')}</h2>
      <form className="login-form" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username">{t('Username:')}</label>
          <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} required />
        </div>
        <div>
          <label htmlFor="userType">{t('UserType:')}</label>
          <select id="userType" value={userType} onChange={(e) => setUserType(e.target.value)} required>
            <option value="">{t('Select User Type')}</option>
            {userTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="password">{t('Password:')}</label>
          <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <button type="submit">{t('Register')}</button>
        {error && <p className="error-message">{error}</p>}
      </form>
    </div>)
  );
}

export default LoginRegister;